var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"shimmer-container",style:(_vm.containerStyle)},_vm._l((_vm.lines),function(n){return _c('div',{key:n,staticClass:"shimmer-line-container"},[(_vm.showAvatar)?_c('div',{staticClass:"shimmer-circle"}):_vm._e(),_c('div',{staticClass:"shimmer-line",style:(_vm.lineStyle)})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }